// ── The standings' dark and light (`EX-SCB03`, `EXAM_TASKS.md` Wave 24) ──────
// The board is dark or light by the reader's choice (Locked Decision 2). A
// first visit follows the device's `prefers-color-scheme`; a press on the
// switch is remembered per browser, for every contest. Stored in
// `localStorage` and wrapped, so a blocked or private store only means the
// device's setting is used again, never that the page breaks. The Big screen
// never reads this: it is always dark (Locked Decision 3).

export type StandingsTheme = "dark" | "light";

export const STANDINGS_THEME_KEY = "progsity:contest:standings-theme";

function deviceTheme(): StandingsTheme {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return "light";
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

/** The reader's remembered choice, else the device's setting. */
export function initialStandingsTheme(): StandingsTheme {
  if (typeof window === "undefined") return "light";
  try {
    const stored = window.localStorage.getItem(STANDINGS_THEME_KEY);
    if (stored === "dark" || stored === "light") return stored;
  } catch {
    // A blocked store: the device decides, every visit.
  }
  return deviceTheme();
}

export function rememberStandingsTheme(theme: StandingsTheme): void {
  try {
    window.localStorage.setItem(STANDINGS_THEME_KEY, theme);
  } catch {
    /* quota or private mode: the choice lasts for this page only */
  }
}
